var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('time-material',{attrs:{"value":_vm.currentValue,"placeholder":_vm.$t('请选择来访时间'),"valid":_vm.valid},on:{"change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }